import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';

import RouterLink from '../../routes/components/RouterLink';

import Logo from '../../components/common/Logo';
import Iconify from './Iconify';

// ----------------------------------------------------------------------

const IsPageLoading = () => {
  const renderHeader = (
    <Box
      component="header"
      sx={{
        top: 0,
        left: 0,
        width: 1,
        lineHeight: 0,
        position: 'fixed',
        p: (theme) => ({ xs: theme.spacing(3, 3, 0), sm: theme.spacing(5, 5, 0) }),
      }}
    >
      <Logo />
    </Box>
  );

  return (
    <>
      {renderHeader}

      <Container>
        <Box
          sx={{
            py: 12,
            maxWidth: 480,
            mx: 'auto',
            display: 'flex',
            minHeight: '100%',
            textAlign: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            justifyContent: 'center',
          }}
        >
          <Typography variant="h3" sx={{ mb: 3 }}>
            Please Wait!
          </Typography>

          <Typography sx={{ color: 'text.secondary' }}>
            Please hold on while we are setting up things for you
          </Typography>

          <Box
            component="img"
            sx={{
              mx: 'auto',
              my: { xs: 5, sm: 10 },
            }}
          />
            <Iconify icon="svg-spinners:blocks-shuffle-3" width="80px"/>
        </Box>
      </Container>
    </>
  );
}

export default IsPageLoading;